import { render } from "./BuildingPasses.vue?vue&type=template&id=6c5978a8"
import script from "./BuildingPasses.vue?vue&type=script&lang=js"
export * from "./BuildingPasses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__